module.exports = __webpack_public_path__ + "img/preview-jimny.c9be99fb.jpg";